let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lRIym")).then(() => parcelRequire('AFoLQ'));